const LIST_ROLES_REQUEST = 'roles/LIST_ROLES_REQUEST';
const LIST_ROLES_FAILURE = 'roles/LIST_ROLES_FAILURE';
const LIST_ROLES_SUCCESS = 'roles/LIST_ROLES_SUCCESS';

const GET_ROLE_REQUEST = 'roles/GET_ROLE_REQUEST';
const GET_ROLE_FAILURE = 'roles/GET_ROLE_FAILURE';
const GET_ROLE_SUCCESS = 'roles/GET_ROLE_SUCCESS';

const CREATE_ROLE_REQUEST = 'roles/CREATE_ROLE_REQUEST';
const CREATE_ROLE_FAILURE = 'roles/CREATE_ROLE_FAILURE';
const CREATE_ROLE_SUCCESS = 'roles/CREATE_ROLE_SUCCESS';

const UPDATE_ROLE_REQUEST = 'roles/UPDATE_ROLE_REQUEST';
const UPDATE_ROLE_FAILURE = 'roles/UPDATE_ROLE_FAILURE';
const UPDATE_ROLE_SUCCESS = 'roles/UPDATE_ROLE_SUCCESS';

const REMOVE_ROLE_REQUEST = 'roles/REMOVE_ROLE_REQUEST';
const REMOVE_ROLE_FAILURE = 'roles/REMOVE_ROLE_FAILURE';
const REMOVE_ROLE_SUCCESS = 'roles/REMOVE_ROLE_SUCCESS';

export default {
  LIST_ROLES_REQUEST,
  LIST_ROLES_FAILURE,
  LIST_ROLES_SUCCESS,

  GET_ROLE_REQUEST,
  GET_ROLE_FAILURE,
  GET_ROLE_SUCCESS,

  CREATE_ROLE_REQUEST,
  CREATE_ROLE_FAILURE,
  CREATE_ROLE_SUCCESS,

  UPDATE_ROLE_REQUEST,
  UPDATE_ROLE_FAILURE,
  UPDATE_ROLE_SUCCESS,

  REMOVE_ROLE_REQUEST,
  REMOVE_ROLE_FAILURE,
  REMOVE_ROLE_SUCCESS,
};
